<template>
  <v-container id="cocinas" tag="section">
    <base-v-component heading="Tipos de cocina del Sistema" />
    <base-material-card
      color="indigo"
      icon="mdi-basket"
      inline
      class="px-5 py-3"
    >
      <v-toolbar flat color="white">
        <v-btn color="success" dark class="mb-2" @click.stop="showDialog()">{{
          formTitle
        }}</v-btn>
        <v-btn
          v-if="isAdmin"
          :loading="loadingTraducir"
          color="secondary"
          dark
          outlined
          small
          class="mb-2 mx-4"
          @click="traducirLoQueSeVe()"
          >Traducir lo que se ve
          <v-icon class="ml-1" small>mdi-google-translate</v-icon></v-btn
        >
        <v-btn
          v-if="!ordenando"
          color="success"
          dark
          class="mx-2 mb-2"
          @click="ordenando = true"
          >Ordenar</v-btn
        >
        <v-btn
          v-if="ordenando"
          color="success"
          dark
          class="mx-2 mb-2"
          @click="ordenando = false"
          >Volver listado</v-btn
        >
        <v-spacer />
        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="reload()">
          <v-icon color="white">mdi-autorenew</v-icon>
        </v-btn>

        <v-dialog v-model="dialog" max-width="500px">
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-select
                  :items="idiomas"
                  v-model="langSeleccionado"
                  label="Selección idioma"
                  outlined
                ></v-select>
                <template v-for="lang in idiomas">
                  <v-layout
                    wrap
                    :key="lang.value"
                    v-if="lang.value == langSeleccionado"
                  >
                    <v-col cols="12">
                      <h4>IDIOMA {{ lang.text }}</h4>
                    </v-col>

                    <v-col cols="6">
                      <v-text-field
                        v-model="nombreShow"
                        label="Nombre"
                        :error-messages="nombreErrors"
                        @input="$v.nombreValidar.$touch()"
                        @blur="$v.nombreValidar.$touch()"
                        ref="nombreReferencia"
                      ></v-text-field>
                    </v-col>
                  </v-layout>
                </template>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="save"
                :loading="loadingForm"
                >Guardar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="cocinasFiltradas"
        :loading="loading"
        :search="search"
        sortBy="orden"
        disable-pagination
        v-if="!ordenando"
      >
        <template v-slot:item.nombre="{ item }">{{ item.nombre }}</template>
        <template v-slot:item.acciones="{ item }">
          <v-card-actions class="pa-0 ma-0">
            <v-spacer></v-spacer>
            <v-btn
              class="px-2 ml-1"
              color="success"
              min-width="0"
              small
              @click="editItem(item)"
            >
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
            <v-btn
              class="px-2 ml-1"
              color="red"
              min-width="0"
              small
              @click="deleteItem(item)"
            >
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </v-card-actions>
        </template>
      </v-data-table>
      <!--<v-row v-else align="center" justify="center">
        <v-col cols="6">
          <v-list>
            <draggable v-model="ordenC">
              <div v-for="element in caracteristicasOrden" :key="element.id">
                <v-list-item>
                  <v-list-item-avatar>
                    <v-icon big>mdi-drag</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>{{mostrarIdioma(element.nombre)}}</v-list-item-content>
                  <v-list-item-action>{{element.orden}}</v-list-item-action>
                </v-list-item>
              </div>
            </draggable>
          </v-list>
        </v-col>
      </v-row>-->
    </base-material-card>
  </v-container>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { mapState, mapGetters } from "vuex";
import draggable from "vuedraggable";
import { mostrarIdioma } from "@/utils/utils.js";
export default {
  mixins: [validationMixin],
  components: {
    draggable,
  },
  validations: {
    nombreValidar: { required },
  },
  data() {
    return {
      loadingTraducir: false,
      id: null,
      nombreIdiomas: null,
      nombreValidar: "",
      search: "",
      ordenando: false,
      loading: false,
      loadingForm: false,
      dialog: false,
      headers: [
        {
          sortable: false,
          text: "Nombre",
          value: "nombreMostrar",
        },
        {
          sortable: false,
          text: "Acciones",
          value: "acciones",
          align: "right",
        },
      ],
      cocinasFiltrando: null,
    };
  },
  computed: {
    nombreErrors() {
      const errors = [];
      if (!this.$v.nombreValidar.$dirty) return errors;
      !this.$v.nombreValidar.required &&
        errors.push("Nombre idioma por defecto obligatorio.");
      return errors;
    },
    ...mapGetters({
      isAdmin: "auth/isAdmin",
      negocio: "app/negocioGestObj",
    }),

    ...mapState({
      cocinas: (state) => state.cocinas.cocinasArray,
      idiomas: "idiomas",
      langDefecto: "langDefecto",
    }),
    cocinasFiltradas() {
      let cocinas = JSON.parse(JSON.stringify(this.cocinas));
      return cocinas.map((e) => {
        console.log(e);
        e.nombreMostrar = mostrarIdioma(e.nombre);
        return e;
      });
    },
    langSeleccionado: {
      get() {
        return this.$store.state.langSeleccionado;
      },
      set(v) {
        this.$store.commit("setLangSeleccionado", v);
      },
    },
    formTitle() {
      return this.isEdit ? "Editar Cocina" : "Nueva Cocina";
    },
    accion() {
      return this.id ? "edit" : "add";
    },
    isAdd() {
      return this.accion == "add";
    },
    isEdit() {
      return this.accion == "edit";
    },
    nombreShow: {
      get() {
        let _vm = this;
        var found = Array.isArray(this.nombreIdiomas)
          ? this.nombreIdiomas.find((e) => e.lang == _vm.langSeleccionado)
          : false;
        return found ? found.text : "";
      },
      set(v) {
        let _vm = this;
        var index = Array.isArray(this.nombreIdiomas)
          ? this.nombreIdiomas.findIndex((e) => e.lang == _vm.langSeleccionado)
          : -1;
        if (index > -1) {
          var defecto = this.nombreIdiomas.find(
            (e) => e.lang == _vm.langDefecto
          );
          this.nombreValidar = defecto.text;
          this.nombreIdiomas[index].text = v;
        }
      },
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  methods: {
    traducirLoQueSeVe() {
      this.loadingTraducir = true;
      let traducir = this.cocinasFiltradas
        .map((prd) => {
          return [
            {
              id: prd.id,
              key: "nombre",
              texto: prd.nombre,
            },
            {
              id: prd.id,
              key: "descripcion",
              texto: prd.descripcion,
            },
          ];
        })
        .flat();
      this.$store
        .dispatch("traducir", traducir)
        .then((r) => {
          console.log(_.groupBy(r, "id"));
          let agrupados = _.groupBy(r, "id");
          var promesas = [];
          for (let prop in agrupados) {
            let propDinamicas = {};
            agrupados[prop].forEach((p) => {
              propDinamicas[p.key] = p.texto;
            });
            console.log(agrupados);
            let objGuardar = {
              id: prop,
              ...propDinamicas,
            };
            console.log(objGuardar);
            // return Promise.resolve();
            promesas.push(
              this.$store
                .dispatch("cocinas/addCocina", {
                  ...objGuardar,
                })
                .catch((e) => console.log(e))
            );
          }
          return Promise.all(promesas);
        })
        .finally(() => {
          this.getCocinas();
          this.loadingTraducir = false;
        });
    },
    reload() {
      this.getCocinas();
    },
    mostrarIdioma(s) {
      return mostrarIdioma(s);
    },

    showDialog() {
      this.dialog = true;
      //this.$nextTick(this.$refs.nombreReferencia.focus())
    },
    editItem(item) {
      this.nombreIdiomas = JSON.parse(JSON.stringify(item.nombre));
      console.log(item);
      this.nombreShow = this.nombreShow;
      this.showDialog();
      this.id = item.id;
    },
    deleteItem(item) {
      let r = confirm(
        "¿Quieres eliminar el tipo de cocina? (no se puede deshacer)"
      );
      if (r) {
        this.loading = true;
        let _vm = this;
        this.$store
          .dispatch("cocinas/deleteCocina", item)
          .then((res) => {
            _vm.$store.commit("snackbar/setMensajeSuccess", {
              msj: "Cocina eliminada",
            });
            _vm.getCocinas();
          })
          .catch((error) => {
            _vm.$store.commit("snackbar/setMensajeDanger", {
              msj: "Error al eliminar",
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    getCocinas() {
      this.loading = true;
      let _vm = this;
      return this.$store.dispatch("cocinas/getCocinas").finally(() => {
        _vm.loading = false;
      });
    },
    close() {
      this.dialog = false;
      this.$v.$reset();
      let _vm = this;
      setTimeout(() => {
        _vm.reiniciarDatos();
      }, 300);
    },
    reiniciarDatos() {
      let a_nombre = [];
      for (var lang of this.idiomas) {
        let aux_1 = { lang: lang.value, text: "" };
        a_nombre.push(aux_1);
      }
      this.id = null;
      this.nombreIdiomas = a_nombre;
      this.$store.commit("setLangSeleccionadoDefecto");
    },
    addCocina() {
      let cocina = {
        nombre: this.nombreIdiomas,
        id: this.id ? this.id : null,
      };
      return this.$store.dispatch("cocinas/addCocina", cocina);
    },
    save() {
      let _vm = this;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.loadingForm = true;
        if (this.isAdd || this.isEdit) {
          this.addCocina()
            .then((res) => {
              _vm.$store.commit("snackbar/setMensajeSuccess", {
                msj: "Cocina grabada con éxito",
              });
              _vm.getCocinas();
              _vm.dialog = false;
            })
            .catch((error) => {
              console.log(error);
              _vm.$store.commit("snackbar/setMensajeDanger", {
                msj: "Error al guardar la cocina",
              });
            })
            .finally(() => {
              _vm.loadingForm = false;
            });
        }
      }
    },
  },
  beforeMount() {
    let a_nombre = [];
    for (var lang of this.idiomas) {
      let aux_1 = { lang: lang.value, text: "" };
      a_nombre.push(aux_1);
    }
    this.nombreIdiomas = a_nombre;
  },
  mounted() {},
};
</script>

<style>
</style>